var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isReady
      ? _c(
          "section",
          { staticClass: "enkai__shops" },
          [
            _c("area-shops", {
              attrs: {
                prefecture: _vm.prefectureNameEn,
                area: _vm.area,
                "area-detail": _vm.areaDetail,
                station: _vm.station,
                price_to: _vm.priceTo,
                people_from: _vm.peopleFrom,
                "shop-type": _vm.shopType,
              },
              on: { shopsCount: _vm.updateShopCount, shops: _vm.updateShops },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "enkai__searchLinks" },
      [
        _c("search-location-links", {
          attrs: {
            "prefecture-name": _vm.prefectureName,
            "prefecture-name-en": _vm.prefectureNameEn,
            area: _vm.area,
            "area-detail": _vm.areaDetail,
            station: _vm.station,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.isPrefecturePage && _vm.shopsCount > 0
      ? _c(
          "section",
          { staticClass: "enkai__faq" },
          [
            _c("area-faq", {
              attrs: {
                "prefecture-name": _vm.prefectureName,
                shopsCount: _vm.shopsCount,
                shops: _vm.shops,
                "areas-in-prefecture": _vm.areasInPrefecture,
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }